import Vue from 'vue'
import App from './App.vue'
import ap from './utils/axiospublic.js'
import VueRouter from 'vue-router'
import Vuex from 'vuex';
import ElementUI from 'element-ui';
import VCharts from 'v-charts'
import 'element-ui/lib/theme-chalk/index.css';
import './utils/dialogDrag';
Vue.use(ElementUI)
Vue.use(Vuex);
Vue.use(VCharts)
Vue.use(VueRouter)
Vue.use(ap)
Vue.config.productionTip = false
const routes = [
  {
    path: '/',
    component:resolve=>require(['@/pages/sys/login'],resolve)
    //component: () => import('./pages/sys/login.vue')
  }, {
    path: '/login',
    component:resolve=>require(['@/pages/sys/login'],resolve)
    //component: () => import('./pages/sys/login.vue')
  }, {
    path: '/resetpassword',
    component:resolve=>require(['@/pages/sys/resetpassword'],resolve)
  },{
    path: '/public/:SID/:YEAR/:VERNO',
    component:resolve=>require(['@/pages/sys/public'],resolve)
    //component: () => import('./pages/sys/public.vue')
  } , {
    path: '/main',
    component:resolve=>require(['@/pages/sys/main'],resolve),
    //component: () => import('./pages/sys/main.vue'),
    redirect: '/main/welcome',
    children: [
      { name:'欢迎页',path: '/main/welcome', component:resolve=>require(['@/pages/sys/welcome'],resolve)},//component: () => import('./pages/sys/welcome.vue') },
      { name:'分院/系部管理',path: '/main/school', component:resolve=>require(['@/pages/bas/school'],resolve)},//component: () => import('./pages/bas/school.vue') },
      { name:'用户管理',path: '/main/user', component:resolve=>require(['@/pages/bas/user'],resolve)},//component: () => import('./pages/bas/user.vue') },
      { name:'指导老师管理',path: '/main/teacher', component:resolve=>require(['@/pages/bas/teacher'],resolve)},//component: () => import('./pages/bas/teacher.vue') },
      { name:'班级管理',path: '/main/classes', component:resolve=>require(['@/pages/bas/classes'],resolve)},//component: () => import('./pages/bas/classes.vue') },
      { name:'学生管理',path: '/main/students', component:resolve=>require(['@/pages/bas/students'],resolve)},//component: () => import('./pages/bas/students.vue') },
      { name:'专业代码',path: '/main/major', component:resolve=>require(['@/pages/bas/major'],resolve)},//component: () => import('./pages/bas/students.vue') },
      { name:'企业管理',path: '/main/enterprise', component:resolve=>require(['@/pages/bas/enterprise'],resolve)},//component: () => import('./pages/bas/students.vue') },
      { name:'任务时间管理',path: '/main/fileclass', component:resolve=>require(['@/pages/sys/fileclass'],resolve)},//component: () => import('./pages/sys/fileclass.vue') },
      { name:'操作日志',path: '/main/log', component:resolve=>require(['@/pages/bas/log'],resolve)},//component: () => import('./pages/bas/log.vue') },
      { name:'毕业设计过程分析',path:'/main/fileready',component:resolve=>require(['@/pages/sys/fileready'],resolve)},//component:()=>import('./pages/sys/fileready.vue')},
      { name:'各环节完成情况',path: '/main/reportfinish',component:resolve=>require(['@/pages/report/reportfinish'],resolve)},// component: () => import('./pages/report/reportfinish.vue') },
      { name:'查重报告分析',path: '/main/reportcc',component:resolve=>require(['@/pages/report/reportanlyze'],resolve)},// component: () => import('./pages/report/reportfinish.vue') },
      { name:'查重检测记录',path: '/main/reportcclist',component:resolve=>require(['@/pages/report/reportcclist'],resolve)},// component: () => import('./pages/report/reportfinish.vue') },
      { name:'获取省厅学生名单',path: '/main/shengget', component:resolve=>require(['@/pages/sheng/shengget'],resolve)},//component: () => import('./pages/sheng/shengget.vue') },
      { name:'校验学生名单',path: '/main/shengchk', component:resolve=>require(['@/pages/sheng/shengchk'],resolve)},//component: () => import('./pages/sheng/shengchk.vue') },
      { name:'成果上传省厅',path: '/main/designupload', component:resolve=>require(['@/pages/sheng/designupload'],resolve)},//component: () => import('./pages/sheng/designupload.vue') },
      { name:'工作文件上传',path: '/main/fileupload/:SFT', component:resolve=>require(['@/pages/mod/fileupload'],resolve)},//component: () => import('./pages/mod/fileupload.vue') },
      { name:'安排指导老师',path: '/main/teacherap/:SFT', component:resolve=>require(['@/pages/mod/teacherap'],resolve)},//component: () => import('./pages/mod/teacherap.vue') },
      { name:'下达任务书',path: '/main/teachersend/:SFT', component:resolve=>require(['@/pages/mod/teachersend'],resolve)},//component: () => import('./pages/mod/teachersend.vue') },
      { name:'学生成绩录入',path: '/main/studentcj/:SFT', component:resolve=>require(['@/pages/mod/studentcj'],resolve)},//component: () => import('./pages/mod/studentcj.vue') },
      { name:'审阅设计成果',path: '/main/designchk/:SFT', component:resolve=>require(['@/pages/mod/designchk'],resolve)},//component: () => import('./pages/mod/designchk.vue') },
      { name:'检查设计成果',path: '/main/designchkap/:CM/:SFT', component:resolve=>require(['@/pages/mod/designchkap'],resolve)},//component: () => import('./pages/mod/designchkap.vue') },
      { name:'撰写设计成果',path: '/main/designedit/:SFT', component:resolve=>require(['@/pages/mod/designedit'],resolve)},//component: () => import('./pages/mod/designedit.vue') },
      { name:'普查工作布置',path: '/main/checkap/:SFT', component:resolve=>require(['@/pages/mod/checkap'],resolve)},//component: () => import('./pages/mod/checkap.vue') },
      { name:'抽查工作布置',path: '/main/checkapout/:SFT', component:resolve=>require(['@/pages/mod/checkapout'],resolve)},//component: () => import('./pages/mod/checkapout.vue') },
      { name:'选题申报',path: '/main/title', component:resolve=>require(['@/pages/titles/title'],resolve)},
      { name:'选题管理',path: '/main/titlepublic', component:resolve=>require(['@/pages/titles/titlepublic'],resolve)},
      { name:'学生选题',path: '/main/titleselect', component:resolve=>require(['@/pages/titles/titleselect'],resolve)},
    ]
  },{
    path:'/outsides',
    component:resolve=>require(['@/pages/outsides/main'],resolve),
    redirect:'/outsides/welcome',
    children:[
      { name:'功能列表',path: '/outsides/welcome', component:resolve=>require(['@/pages/outsides/welcome'],resolve)},
      { name:'选题申报',path: '/outsides/title', component:resolve=>require(['@/pages/outsides/title'],resolve)},
      { name:'选题管理',path: '/outsides/titlepublic', component:resolve=>require(['@/pages/outsides/titlepublic'],resolve)},
      { name:'学生选题',path: '/outsides/titleselect', component:resolve=>require(['@/pages/outsides/titleselect'],resolve)},

      { name:'安排指导老师',path: '/outsides/teacherap', component:resolve=>require(['@/pages/outsides/teacherap'],resolve)},//component: () => import('./pages/mod/teacherap.vue') },
      { name:'下达任务书',path: '/outsides/teachersend', component:resolve=>require(['@/pages/outsides/teachersend'],resolve)},//component: () => import('./pages/mod/teachersend.vue') },
      { name:'学生成绩录入',path: '/outsides/studentcj', component:resolve=>require(['@/pages/outsides/studentcj'],resolve)},//component: () => import('./pages/mod/studentcj.vue') },
      { name:'审阅设计成果',path: '/outsides/designchk', component:resolve=>require(['@/pages/outsides/designchk'],resolve)},//component: () => import('./pages/mod/designchk.vue') },
      { name:'检查设计成果',path: '/outsides/designchkap/:CM', component:resolve=>require(['@/pages/outsides/designchkap'],resolve)},//component: () => import('./pages/mod/designchkap.vue') },
      { name:'撰写设计成果',path: '/outsides/designedit', component:resolve=>require(['@/pages/outsides/designedit'],resolve)},//component: () => import('./pages/mod/designedit.vue') },
    ]
  }]

const router = new VueRouter({
  routes
})
const store = new Vuex.Store({
  currentmodule: {}
});
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
